import React, { createRef, useState, useMemo } from 'react';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure } from 'react-instantsearch-hooks-web';
import { Link } from 'gatsby';
import useClickOutside from 'helpers/use-click-outside';
import paths from 'constants/paths';
import { PopularTopicType } from 'components/header/types';
import SearchBox from './search-box';
import SearchResult from './search-result';
import * as styles from './search-styles.module.scss';

interface SearchProps {
  leftIndices: { name: string }[];
  rightIndices: { name: string }[];
  popularTopics: PopularTopicType[];
}

const Search = ({ leftIndices, rightIndices, popularTopics }: SearchProps) => {
  const rootRef = createRef<HTMLDivElement>();
  const [query, setQuery] = useState<string | undefined>();
  const [hasFocus, setFocus] = useState(false);
  const searchClient = useMemo(
    () => algoliasearch(
      process.env.GATSBY_ALGOLIA_APP_ID || '',
      process.env.GATSBY_ALGOLIA_SEARCH_KEY || '',
    ),
    [],
  );

  useClickOutside(rootRef, () => setFocus(false));

  return (
    <div className={styles.searchContainer}>
      <div ref={rootRef} className={styles.searchRoot}>
        <InstantSearch
          searchClient={searchClient}
          indexName={rightIndices[0].name}
          routing
          insights
        >
          <div className={styles.leftSide}>
            <SearchBox
              onChange={(queryInput: string) => setQuery(queryInput)}
              className={styles.searchBoxWrapper}
              onFocus={() => setFocus(true)}
            />
            <Configure hitsPerPage={5} />
            <div className={styles.topicsContainer}>
              {popularTopics?.length > 0 && !hasFocus ? (
                <div className={styles.popularTopics}>
                  <span className={styles.popularTopicTitle}>Popular Topics</span>
                  {popularTopics.map((topic) => (
                    <Link replace to={`${paths.searchPageAll}${topic.item}`} className={styles.popularTopicItem}>{topic.item}</Link>
                  ))}
                </div>
              )
                : (
                  <SearchResult
                    show={(query?.length && hasFocus) || false}
                    indices={leftIndices}
                  />
                )}
            </div>
          </div>
          <div className={styles.rightSide}>
            <SearchResult
              show={(query?.length && hasFocus) || false}
              indices={rightIndices}
            />
          </div>
        </InstantSearch>
      </div>
    </div>
  );
};

export default Search;
